import AutoPresHigh from './automated_presentation-high.json'
import AutoPresLow from './automated_presentation-low.json'
import AutoPresMedium from './automated_presentation-medium.json'

import AutoSupHigh from './automated_supervised-high.json'
import AutoSupLow from './automated_supervised-low.json'
import AutoSupMedium from './automated_supervised-medium.json'

import FewInsMoni from './few_ins_moni.json'
import FewMoniIns from './few_moni_ins.json'
import ManyInsMoni from './many_ins_moni.json'
import ManyMoniIns from './many_moni_ins.json'

// Export all examples in a array
export default [
  AutoPresHigh, AutoPresMedium, AutoPresLow,
  AutoSupHigh, AutoSupMedium, AutoSupLow,

  FewInsMoni, FewMoniIns,
  ManyInsMoni, ManyMoniIns
]
